<template>
  <div class="banner-wrapper owl-theme owl-carousel" ref="owlCarousel">
    <div class="banner-items" v-for="(item, index) in items" :key="item.game_id">
      <div class="container-fluid">
        <div class="banner-content">
          <h1></h1>
          <h2 class="text-base">{{ item.title }}</h2>
          <h3></h3>
          <div class="cmn--grp">
            <a href="#" class="cmn--btn cd-popup-trigger"
            @click.prevent="$router.push({ name: 'game.show', params: { slug: item.slug } })">
              <span>{{ $t("Play") }}</span>
            </a>
            <!-- <a href="#" class="border-btn">
              <span>More info</span>
            </a> -->
          </div>
        </div>
      </div>
      <div class="banner-shape" style="max-width: 100%; width: 100%; opacity: 0.3;">
        <!-- First 2 images load eagerly (above the fold), rest are lazy loaded -->
        <img 
          v-if="index < 2"
          :src="item.slider" 
          alt="banner-shape" 
          style="object-fit: cover;"
          fetchpriority="high"
        />
        <img 
          v-else
          v-lazy="item.slider" 
          alt="banner-shape" 
          style="object-fit: cover;"
          loading="lazy"
          decoding="async"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { onMounted, onBeforeUnmount, ref, watch, nextTick } from "vue";
import "owl.carousel";
import $ from "jquery";

export default {
  name: "HomeBanner",
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    const owlCarousel = ref(null);

    const destroyCarousel = () => {
      if (owlCarousel.value && $(owlCarousel.value).hasClass("owl-loaded")) {
        $(owlCarousel.value).trigger("destroy.owl.carousel");
        $(owlCarousel.value).removeClass("owl-loaded owl-drag");
      }
    };

    const initializeCarousel = () => {
      // Destroy and reinitialize the carousel if it's already initialized
      destroyCarousel();

      $(owlCarousel.value).owlCarousel({
        loop: true,
        margin: 0,
        smartSpeed: 2500,
        autoplayTimeout: 3000,
        autoplay: false,
        nav: true,
        dots: true,
        responsiveClass: true,
        navText: $('html').attr('dir') === 'rtl'? [
          '<i class="fas fa-chevron-right"></i>',
          '<i class="fas fa-chevron-left"></i>',
        ] : [
          '<i class="fas fa-chevron-left"></i>',
          '<i class="fas fa-chevron-right"></i>',
        ],
        rtl: $('html').attr('dir') === 'rtl',
        responsive: {
          0: {
            items: 1,
          },
          500: {
            items: 1,
          },
          767: {
            items: 1,
          },
          991: {
            items: 1,
          },
          1199: {
            items: 1,
          },
          1399: {
            items: 1,
          },
        },
      });
    };

    // Initialize the carousel on mount
    onMounted(() => {
      nextTick(() => {
        initializeCarousel();
      });
    });

    // Clean up carousel on unmount to prevent memory leaks
    onBeforeUnmount(() => {
      destroyCarousel();
    });

    // Watch for changes in the `items` prop and reinitialize the carousel
    watch(
      () => props.items,
      (newItems, oldItems) => {
        if (newItems !== oldItems) {
          nextTick(() => {
            initializeCarousel();
          });
        }
      }
    );

    return {
      owlCarousel,
    };
  },
};
</script>

<style scoped>
/* Add any necessary styling for your owl carousel */
</style>
